
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands.html",
      function () {
        return require("private-next-pages/brands.html.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands.html"])
      });
    }
  